import React from "react";
import {
  Box,
  HStack,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";

export default function SummarySkeleton() {
  const headerBg = useColorModeValue("gray.200", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");

  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };

  const columnWidths = [65, 70, 65, 55, 70, 55, 50, 55, 50, 40, 55, 50, 80];

  return (
    <>
      {/* Filter Bar */}
      <HStack spacing={3} flexWrap="wrap">
        <Skeleton height="32px" width="100px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="24px" width="70px" borderRadius="full" {...skeletonProps} />
        <Skeleton height="24px" width="55px" borderRadius="full" {...skeletonProps} />
      </HStack>

      {/* Action Buttons */}
      <HStack spacing={2} flexWrap="wrap">
        <Skeleton height="32px" width="85px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="60px" borderRadius="md" {...skeletonProps} />
        <Box flex="1" />
        <Skeleton height="32px" width="70px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="70px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="100px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="60px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="65px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Pagination */}
      <HStack spacing={3} justifyContent="flex-end">
        <Skeleton height="24px" width="90px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="24px" width="120px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Table */}
      <Box borderWidth="1px" borderColor={borderColor} rounded="lg" overflow="hidden">
        {/* Table Header */}
        <HStack bg={headerBg} px={3} py={2} spacing={4} overflowX="auto">
          {columnWidths.map((w, i) => (
            <Skeleton key={i} height="12px" width={`${w}px`} flexShrink={0} {...skeletonProps} />
          ))}
        </HStack>
        {/* Table Rows */}
        {[0, 1, 2, 3, 4].map((row) => (
          <HStack key={row} px={3} py={3} spacing={4} borderTopWidth="1px" borderColor={borderColor} overflowX="auto">
            {columnWidths.map((w, col) => (
              <Skeleton key={col} height="12px" width={`${w - 10 + Math.floor(Math.random() * 20)}px`} flexShrink={0} {...skeletonProps} />
            ))}
          </HStack>
        ))}
      </Box>
    </>
  );
}
